import { render, staticRenderFns } from "./Totales.vue?vue&type=template&id=28acb571&"
import script from "./Totales.vue?vue&type=script&lang=js&"
export * from "./Totales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports